<powerbi-component id="embed-container" options="ctrl.response"></powerbi-component>